// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import Information from './component/information/Information';
import Announcement from './component/announcement/Announcement';
import Course from './component/course/Course';
import Lirn from './component/lirn/Lirn';
// Others
// Styles, images, icons
import styles from './Home.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const Home = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/home']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function
  return (
    <div className={cx('container')}>
      <div className={cx('leftSection')}>
        <div className={cx('topBox')}>{<Information />}</div>

        <div className={cx('bottomBox')}>
          <div className={cx('smallBox')}>{<Announcement />}</div>

          <div className={cx('smallBox')}>{<Lirn />}</div>
        </div>
      </div>

      <div className={cx('rightSection')}>
        <Course />
      </div>
    </div>
  );
};

export default Home;
